<template>
  <div>
    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'fb8'">
      Please detail your two <confection-choices :value="1">confection choices</confection-choices> in the comments below.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'fb16'">
      Please detail your centerpiece and two <confection-choices :value="2">confection choices</confection-choices> in the comments below.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && (details === 'fb36' || details === 'fbtr')">
      Please detail your centerpiece, two <stock-themed-pieces :value="3">themed chocolate choices</stock-themed-pieces>,
      two <confection-choices :value="4">confection choices</confection-choices>
      and <truffle-choices :value="5">truffle choices</truffle-choices> in the comments below.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'fc2'">
      Please detail the chocolate type (milk or dark) for your two <stock-themed-pieces :value="6">themed chocolate choices</stock-themed-pieces> or you may describe your design in the comments below and upload a custom logo file (additional charge may apply for custom logos).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'fc4'">
      Please detail the chocolate type (milk or dark) for your two <stock-themed-pieces :value="7">themed chocolate choices</stock-themed-pieces> (you'll receive 2 of each in the box) or you may describe your design in the comments below and upload a custom logo file (additional charge may apply for custom logos).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'fc8'">
      Please detail the chocolate type (milk or dark) for your two <stock-themed-pieces :value="8">themed chocolate choices</stock-themed-pieces> (you'll receive 4 of each in the box) or you may describe your design in the comments below and upload a custom logo file (additional charge may apply for custom logos).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'hb3'">
      Please detail the chocolate types (milk or dark) for the 3 hearts in the comments below.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'hbwt'">
      Please detail your two <truffle-choices :value="9">truffle choices</truffle-choices> in the comments below.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'hbwc'">
      Please detail your two <confection-choices :value="10">confection choices</confection-choices> in the comments below.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'ewcbg'">
      Please detail your <confection-choices :value="11">confection choice</confection-choices> in the comments below.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'dwcbg'">
      Please detail your two <confection-choices :value="12">confection choice</confection-choices> in the comments below.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'sq4'">
      Please detail your centerpiece and the chocolate type (milk or dark) for
      your two <stock-themed-square-pieces :value="13">themed chocolate choices</stock-themed-square-pieces> (you'll receive 2 of each in the box) or you may describe your design in the comments below and upload a custom logo file (additional charge may apply for custom logos).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'sq8'">
      Please detail your centerpiece and the chocolate type (milk or dark) for
      your two <stock-themed-square-pieces :value="14">themed chocolate choices</stock-themed-square-pieces> (you'll receive 4 of each in the box) or you may describe your design in the comments below and upload a custom logo file (additional charge may apply for custom logos).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'sq16'">
      Please detail your centerpiece and the chocolate type (milk or dark) for
      your two <stock-themed-square-pieces :value="15">themed chocolate choices</stock-themed-square-pieces> (you'll receive 8 of each in the box) or you may describe your design in the comments below and upload a custom logo file (additional charge may apply for custom logos).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'sq32'">
      Please detail your centerpiece and the chocolate type (milk or dark) for
      your two <stock-themed-square-pieces :value="16">themed chocolate choices</stock-themed-square-pieces> (you'll receive 16 of each in the box) or you may describe your design in the comments below and upload a custom logo file (additional charge may apply for custom logos).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'sq64'">
      Please detail your centerpiece and the chocolate type (milk or dark) for
      your two <stock-themed-square-pieces :value="17">themed chocolate choices</stock-themed-square-pieces> (you'll receive 32 of each in the box) or you may describe your design in the comments below and upload a custom logo file (additional charge may apply for custom logos).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'tr8'">
      Please detail your centerpiece and the chocolate type (milk or dark) for
      your two <stock-themed-pieces :value="18">themed chocolate choices</stock-themed-pieces> (you'll receive 4 of each in the box). You may describe your centerpiece design in the comments below or upload a custom logo file (additional charge may apply for custom artwork).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'tr16'">
      Please detail your centerpiece and the chocolate type (milk or dark) for
      your two <stock-themed-pieces :value="19">themed chocolate choices</stock-themed-pieces> (you'll receive 8 of each in the box). You may describe your centerpiece design in the comments below or upload a custom logo file (additional charge may apply for custom artwork).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'tr24'">
      Please detail your centerpiece and the chocolate type (milk or dark) for
      your two <stock-themed-pieces :value="20">themed chocolate choices</stock-themed-pieces> (you'll receive 12 of each in the box). You may describe your centerpiece design in the comments below or upload a custom logo file (additional charge may apply for custom artwork).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'tr48'">
      Please detail your centerpiece and the chocolate type (milk or dark) for
      your two <stock-themed-pieces :value="21">themed chocolate choices</stock-themed-pieces> (you'll receive 24 of each in the box). You may describe your centerpiece design in the comments below or upload a custom logo file (additional charge may apply for custom artwork).
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'bt2'">
      Please detail your two <truffle-choices :value="22">truffle choices</truffle-choices> in the comments below.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'bt4'">
      Please detail up to four <truffle-choices :value="23">truffle choices</truffle-choices> in the comments below. You may request to have a certain amount each truffle choice as well.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'bt8'">
      Please detail your centerpiece and up to four <truffle-choices :value="24">truffle choices</truffle-choices> in the comments below. You may request to have a certain amount each truffle choice as well.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'bt9'">
      Please detail up to four <truffle-choices :value="25">truffle choices</truffle-choices> in the comments below. You may request to have a certain amount each truffle choice as well.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'bt12'">
      Please detail your centerpiece and up to four <truffle-choices :value="25">truffle choices</truffle-choices> in the comments below. You may request to have a certain amount each truffle choice as well.
    </div>

    <div class="px-4 py-2 border border-dashed border-red-800 font-bold" v-if="details && details === 'bt20'">
      Please detail your centerpiece and up to four <truffle-choices :value="26">truffle choices</truffle-choices> in the comments below. You may request to have a certain amount each truffle choice as well.
    </div>
  </div>
</template>

<script>
    import ConfectionChoices from "./modals/ConfectionChoices";
    import StockThemedPieces from "./modals/StockThemedPieces";
    import StockThemedSquarePieces from "./modals/StockThemedSquarePieces";
    import TruffleChoices from "./modals/TruffleChoices";
  export default {
    props: ['details'],
      components: {
          ConfectionChoices,
          StockThemedPieces,
          StockThemedSquarePieces,
          TruffleChoices
      },

    data () {
      return {}
    },

    methods: {}
  }
</script>
